/**
 * @fileoverview POST handler for the "/engagement/webhook_templates/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementWebhookTemplatesUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementWebhookTemplatesUpdateArchivedStateProps,
  EngagementWebhookTemplatesUpdateArchivedStateResult,
} from "./types";

export const postEngagementWebhookTemplatesUpdateArchivedState = reactQueryMutationAdapter(
  engagementWebhookTemplatesUpdateArchivedStateCacheKeys,
  (
    props: PostEngagementWebhookTemplatesUpdateArchivedStateProps
  ): Promise<EngagementWebhookTemplatesUpdateArchivedStateResult> => {
    return fetch("/engagement/webhook_templates/update_archived_state", "POST", props);
  }
);
